import { createSlice } from "@reduxjs/toolkit";
const initialState = {
  orders: [],
  openStaus: null,
  menu: [],
  newCategories: [],
};

const OrderSlice = createSlice({
  name: "order",
  initialState,
  reducers: {
    addOrder: (state, action) => {
      state.orders = action.payload;
    },
    addNewOrder: (state, action) => {
      // Check if an order with this ID already exists in the state
      const orderExists = state.orders.some(
        (order) => order.id === action.payload.id
      );

      // Only add the order if it doesn't already exist
      if (!orderExists) {
        state.orders = [action.payload, ...state.orders];
      }
    },

    acceptOrderTakeaway: (state, action) => {
      const { id, time } = action.payload; // Extract id and time from payload

      const findOrderIndex = state.orders.findIndex((order) => order.id === id);

      if (findOrderIndex !== -1) {
        state.orders[findOrderIndex].user.orderStatus = "Preparing";
        state.orders[findOrderIndex].user.ETA = time;

        const [updatedOrder] = state.orders.splice(findOrderIndex, 1);
        state.orders.unshift(updatedOrder);
      }
    },
    acceptOrderDineIn: (state, action) => {
      const { id, time, tableNo } = action.payload; // Extract id and time from payload

      const findOrderIndex = state.orders.findIndex((order) => order.id === id);

      if (findOrderIndex !== -1) {
        state.orders[findOrderIndex].user.orderStatus = "Preparing";
        state.orders[findOrderIndex].user.ETA = time;
        state.orders[findOrderIndex].user.tableNo = tableNo;

        const [updatedOrder] = state.orders.splice(findOrderIndex, 1);
        state.orders.unshift(updatedOrder);
      }
    },
    updateOrderDine: (state, action) => {
      const { id, tableNo } = action.payload; // Extract id and time from payload
      const order = state.orders.find((order) => order.id === id);
      order.user.tableNo = tableNo;
    },
    orderReject: (state, action) => {
      const findOrder = state.orders.find(
        (order) => order.id === action.payload
      );
      if (findOrder) {
        findOrder.user.orderStatus = "Cancelled";
      }
    },
    openStatus: (state, action) => {
      state.openStaus = action.payload;
    },
    addMenu: (state, action) => {
      state.menu = action.payload;
    },
    markAvailable: (state, action) => {
      action.payload.forEach((id) => {
        const findMenu = state.menu.find((menu) => menu._id === id);
        if (findMenu) {
          findMenu.available = !findMenu.available;
        }
      });
    },
    removeItem: (state, action) => {
      state.menu = state.menu.filter((menu) => menu._id !== action.payload);
    },
    removeMultipleItems: (state, action) => {
      state.menu = state.menu.filter(
        (menu) => !action.payload.includes(menu._id)
      );
    },
    logout: (state) => {
      state.orders = [];
      state.openStaus = null;
      state.menu = [];
      state.newCategories = [];
    },
    updateStaus: (state, action) => {
      const findOrder = state.orders.find(
        (order) => order.id === action.payload.id
      );
      if (findOrder) {
        findOrder.user.orderStatus = action.payload.status;
      }
    },
    editMenuDetails: (state, action) => {
      const findMenu = state.menu.find(
        (menu) => menu._id === action.payload.dishDetails._id
      );
      if (findMenu) {
        if (findMenu.dishId.dishName !== action.payload.dishName) {
          findMenu.dishId.dishName = action.payload.dishName;
        }
        if (
          findMenu.dishId.dishCatagory !== action.payload.category &&
          action.payload.category === "Others"
        ) {
          findMenu.dishId.dishCatagory = action.payload.addNewCategory;
        } else if (
          findMenu.dishId.dishCatagory !== action.payload.category &&
          action.payload.category !== "Others"
        ) {
          findMenu.dishId.dishCatagory = action.payload.category;
        }

        if (findMenu.resturantDishPrice !== action.payload.price) {
          findMenu.resturantDishPrice = action.payload.price;
        }

        if (findMenu.dishId.dishDescription !== action.payload.dishDescription) {
          findMenu.dishId.dishDescription = action.payload.dishDescription;
        }

        if (action.payload.images && action.payload.images.length > 0) {
          findMenu.dishId.dishImageUrl = action.payload.images;
        }

        findMenu.dishId.dishType = action.payload.isVeg ? 0 : 1;
      }
    },
    addNewCategory: (state, action) => {
      state.newCategories = action.payload;
    },
    updateNewCategory: (state, action) => {
      const { oldName, newName, selectedItems } = action.payload;

      const index = state.newCategories.findIndex(
        (category) => category === oldName
      );

      if (index !== -1) {
        // Update the old name to the new name
        state.newCategories[index] = newName;
      }
      state.menu.forEach((item) => {
        if (selectedItems.includes(item._id)) {
          item.dishId.dishCatagory = newName;
        }
      });
    },
    deleteCategory: (state, action) => {
      const { category } = action.payload;
      state.newCategories = state.newCategories.filter(
        (item) => item !== category
      );
    },
    markAllItemsUnavailable: (state, action) => {
      const { category, status } = action.payload;
      state.menu.forEach((item) => {
        if (item.dishId.dishCatagory === category) {
          item.available = status;
        }
      });
    },
    addNewItem: (state, action) => {
      state.menu = [action.payload, ...state.menu];
    },
    addNewCategoriesOtherThanList: (state, action) => {
      state.newCategories = [...state.newCategories, action.payload];
    },
    clearRestaurantData: (state) => {
      state.orders = [];
      state.menu = [];
      state.newCategories = [];
    },
  },
});
export const {
  addOrder,
  openStatus,
  addNewOrder,
  addMenu,
  acceptOrderTakeaway,
  acceptOrderDineIn,
  orderReject,
  markAvailable,
  removeItem,
  logout,
  updateStaus,
  editMenuDetails,
  addNewCategory,
  updateNewCategory,
  markAllItemsUnavailable,
  removeMultipleItems,
  updateOrderDine,
  addNewItem,
  deleteCategory,
  addNewCategoriesOtherThanList,
  clearRestaurantData,
} = OrderSlice.actions;
export default OrderSlice.reducer;
